// extracted by mini-css-extract-plugin
export default {"root":"Avatar_root__7Ub7Q"};